// extracted by mini-css-extract-plugin
module.exports = {"label":"JiraBoardSelector_label__qGyYi","root":"JiraBoardSelector_root__39ZJr"};